const cartResource = '/cart'
const cartItemResource = '/cart-item'

export default {
  getCart (vue, config) {
    return vue.axios.get(`${cartResource}`, config)
  },
  emptyCart (vue, config) {
    return vue.axios.delete(`${cartResource}`, config)
  },
  updateItem (vue, data, config) {
    return vue.axios.patch(`${cartItemResource}`, data, config)
  },
  deleteItem (vue, itemId, config) {
    return vue.axios.delete(`${cartItemResource}/${itemId}`, config)
  },
  addItem (vue, item, config) {
    return vue.axios.post(`${cartItemResource}`, item, config)
  }
}
